<template>
  <iframe
    id="main_iframe"
    frameborder="0"
    style="display:block"
    height="100%"
    :data-path='path'
    width="100%"></iframe>
</template>

<script>
import { setTimeout } from "timers";


 window['load_iframe'] = {
  name: "load_iframe",
  components: {},
  data() {
    return {
    }
  },
  methods: {
    load(path) {
      let vm = this;
      console.log('iframe path',path);
      let tokenCookie = this.getCookie('accesstoken') ? JSON.parse(this.getCookie('accesstoken')) : '';
      tokenCookie = (tokenCookie&&tokenCookie.access_token) ? tokenCookie.access_token : '';

      let aa = 0;
      if(path.indexOf('pan.bjmyedu.cn') != -1 || path.indexOf('lib.bjmyedu.cn') != -1 || path.indexOf('117.116.30.149') != -1){
         aa = 1;
      }else if(path.indexOf('openedu.baidu.com') !=- 1){
         aa = 2;
      }
      if(aa==1){
        $('#main_iframe').attr('src', path);
      }else if(aa==2){
        // 百度文库
        //https://openedu.baidu.com/product/miyun?token=N9oNYznELeIo719NYx3NNeyeRVJlrH84&product=bjmy&uid=123
        // https://openedu.baidu.com/product/miyun?token={token}&product=bjmy&uid={workId}
        let baiduToken = getCookie('baiduToken') ? getCookie('baiduToken') : '';
        path = path.replace('{token}',baiduToken);
        path = path.replace('{workId}',window.userInfo.workId)
        $('#main_iframe').attr('src', path);
      }else{
        $('#main_iframe').attr('src', path + '?token=' + tokenCookie);
      }
      
    }
  },
  computed:{
    path:vm=>{
      let param = vm.$param('load_iframe');
      vm.load(param.path)
      return vm.$param('load_iframe').path
    }
  },
  mounted() {
    let vm = this;
    // const url = decodeURIComponent(this.$route.params.path)
    setTimeout(_=>{
      let param = vm.$param('load_iframe');
      vm.load(param.path)
    },200)
   
  },
}

export default window['load_iframe'];
</script>



// WEBPACK FOOTER //
// src/commonplugin/load_iframe.vue